import { render, staticRenderFns } from "./OrderSelectBrand.vue?vue&type=template&id=01e60cb2&"
import script from "./OrderSelectBrand.vue?vue&type=script&lang=js&"
export * from "./OrderSelectBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports